import type {
  ReloadStopCargoConfigCreateApiData,
  ReloadStopCargoConfigCreateApiResponses,
  ReloadStopCargoConfigListApiData,
  ReloadStopCargoConfigListApiResponses,
  ReloadStopCargoConfigPatchApiData,
  ReloadStopCargoConfigPatchApiResponses,
  ReloadStopCreateApiData,
  ReloadStopCreateApiResponses,
  ReloadStopDeleteApiData,
  ReloadStopDeleteApiResponses,
  ReloadStopGetApiData,
  ReloadStopGetApiResponses,
  ReloadStopListApiData,
  ReloadStopListApiResponses,
  ReloadStopPatchApiData,
  ReloadStopPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getReloadStopUrls = {
  getPaginatedReloadStops: dataEndpoint<ReloadStopListApiData, ReloadStopListApiResponses>({
    getUrl: (queryParams) => apiUrl('reload-stops/', queryParams)
  }),
  getReloadStop: dataEndpoint<ReloadStopGetApiData, ReloadStopGetApiResponses>({
    getUrl: ({ reloadStopId }) => apiUrl(`reload-stops/${reloadStopId}/`)
  }),
  postReloadStop: responseEndpoint<ReloadStopCreateApiData, ReloadStopCreateApiResponses>({
    getUrl: () => apiUrl('reload-stops/'),
    getBody: (data) => data
  }),
  patchReloadStop: responseEndpoint<ReloadStopPatchApiData, ReloadStopPatchApiResponses>({
    getUrl: ({ reloadStopId }) => apiUrl(`reload-stops/${reloadStopId}/`),
    getBody: (data) => data
  }),
  deleteReloadStop: dataEndpoint<ReloadStopDeleteApiData, ReloadStopDeleteApiResponses>({
    getUrl: ({ reloadStopId }) => apiUrl(`reload-stops/${reloadStopId}/`)
  }),
  getPaginatedReloadStopCargoConfigs: dataEndpoint<
    ReloadStopCargoConfigListApiData,
    ReloadStopCargoConfigListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('reload-stop-cargo-configs/', queryParams)
  }),
  postReloadStopCargoConfig: responseEndpoint<
    ReloadStopCargoConfigCreateApiData,
    ReloadStopCargoConfigCreateApiResponses
  >({
    getUrl: () => apiUrl('reload-stop-cargo-configs/'),
    getBody: (data) => data
  }),
  patchReloadStopCargoConfig: responseEndpoint<
    ReloadStopCargoConfigPatchApiData,
    ReloadStopCargoConfigPatchApiResponses
  >({
    getUrl: ({ reloadStopCargoConfigId }) => apiUrl(`reload-stop-cargo-configs/${reloadStopCargoConfigId}/`),
    getBody: (data) => data
  })
};
